<template>
    <div class="searchcontainer d-flex bg-utel-v2-secondary rounded-8 sin-borde text-primary mx-1 my-sm-2">
        <div class="searchicon">
            <i class="fas fa-search"></i>
        </div>
        <input
            @input="onInputChange"
            v-model="search"
            class="searchinput text-primary"
            :class="{ expanded: isExpanded || search?.trim().length > 0 }"
            type="text"
            placeholder="Buscar por nombre"
        >
    </div>
</template>
<script>
    export default {
        props: ['searchText', 'expanded'],
        data(){
            return {
                search: this.searchText,
                isExpanded: !!this.expanded ?? false
            }
        },
        methods: {
            onInputChange(){
                this.$emit('onSearch', this.search);
            }
        }
    }
</script>
<style>

.searchinput{
    background: none;
    border: none;
    color: #1A0054;
    font-size: 16px;
    outline: none;
    padding: 0;
    transition: 0.4s;
    width: 0;
}

.searchinput.expanded{
    width: 240px;
    padding: 5px 6px;
}

.searchcontainer:hover>.searchinput:not(.expanded){
    width: 240px;
    padding: 0 6px;
}

.searchicon{
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.searchcontainer{
    border: 1px solid;
}
</style>
